import { LitElement, html, css } from 'lit';
import { grid } from '../../utilities/styles';
export class AllInGreeting extends LitElement {
    static properties = {
        loggedIn: { type: Boolean },
        userName: { type: String },
        greeting: { type: String },
    };
    constructor() {
        super();
        this.greeting = 'Hi';
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('allin-login', this._onLogin);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('allin-login', this._onLogin);
    }
    _onLogin = (e) => {
        if (e.detail.loggedIn) {
            this.loggedIn = true;
            this.userName = e.detail.name;
        }
        else {
            this.loggedIn = false;
        }
    };
    render() {
        let markup;
        if (this.loggedIn) {
            markup = html `\n                ${this.greeting} ${this.userName}\n            `;
        }
        return html ` \n        <span class="greeting">\n            <slot></slot>\n            ${markup}\n        </span>\n        `;
    }
    static styles = [
        grid,
        css `
        :host {
            font-family:var(--allin-font-family,inherit);
            font-size:var(--allin-font-size,1rem);
            color:var(--allin-text-color,#000);
            background-color:var(--allin-bg-color,transparent);
            padding:var(--allin-padding,0);
            font-weight: var(--allin-font-weight, normal);
            
        }
        .greeting{
            margin: var(--allin-margin, 0 0 1.5rem 0);
            display:inline-block;
        }
    `
    ];
}
